// The bundled fonts (M14): OFL-1.1 families only, static weights, Latin subset (covers English and Spanish:
// á é í ó ú ü ñ ¿ ¡). Files live in public/fonts/<dir>/ with the family's OFL.txt; scripts/copy-fonts.ts
// copies them from the @fontsource packages (dev dependencies) and scripts/assets-manifest.ts lists them for
// the licence check.
export type FontFamily = {
  family: string;
  dir: string;
  weights: number[];
  kind: 'sans' | 'serif' | 'display' | 'script' | 'mono';
};

export const FONT_FAMILIES: FontFamily[] = [
  { family: 'Montserrat', dir: 'montserrat', weights: [400, 700, 800], kind: 'sans' },
  { family: 'Poppins', dir: 'poppins', weights: [400, 600, 800], kind: 'sans' },
  { family: 'Lato', dir: 'lato', weights: [400, 700], kind: 'sans' },
  { family: 'Oswald', dir: 'oswald', weights: [400, 600, 700], kind: 'sans' },
  { family: 'Bebas Neue', dir: 'bebas-neue', weights: [400], kind: 'display' },
  { family: 'Anton', dir: 'anton', weights: [400], kind: 'display' },
  { family: 'Playfair Display', dir: 'playfair-display', weights: [400, 700, 900], kind: 'serif' },
  { family: 'Lora', dir: 'lora', weights: [400, 700], kind: 'serif' },
  { family: 'DM Serif Display', dir: 'dm-serif-display', weights: [400], kind: 'serif' },
  { family: 'Pacifico', dir: 'pacifico', weights: [400], kind: 'script' },
  { family: 'Caveat', dir: 'caveat', weights: [700], kind: 'script' },
  { family: 'Amatic SC', dir: 'amatic-sc', weights: [400, 700], kind: 'script' },
  // M21b: the receipt-style ad (a typewriter / till-roll monospace).
  { family: 'Courier Prime', dir: 'courier-prime', weights: [400, 700], kind: 'mono' },
];

export const fontFile = (f: FontFamily, weight: number) =>
  `fonts/${f.dir}/${f.dir}-latin-${weight}-normal.woff`;
export const fontKey = (family: string, weight: number) => `${family}:${weight}`;
export const familyOf = (family: string) => FONT_FAMILIES.find((f) => f.family === family);

/** The closest weight the family has (ties go to the heavier one). Unknown family → Montserrat. */
export function nearestWeight(family: string, weight: number): { family: string; weight: number } {
  const f = familyOf(family) ?? FONT_FAMILIES[0]!;
  let best = f.weights[0]!;
  for (const w of f.weights)
    if (
      Math.abs(w - weight) < Math.abs(best - weight) ||
      (Math.abs(w - weight) === Math.abs(best - weight) && w > best)
    )
      best = w;
  return { family: f.family, weight: best };
}
